import { useEffect, useState } from 'react'
import { INGREDIENT_PRODUCTS_RDB } from '__constants__'
import database from 'services/firebase/database'
import { onValue, ref as databaseRef } from 'firebase/database'

const EMPTY_PRODUCT_IDS = []

const useGetIngredientProductIds = (ingredientId) => {
  const [state, setState] = useState({
    ingredientId: null,
    productIds: EMPTY_PRODUCT_IDS,
    loading: false
  })

  useEffect(() => {
    if (!ingredientId) {
      setState({
        ingredientId: null,
        productIds: EMPTY_PRODUCT_IDS,
        loading: false
      })
      return undefined
    }

    setState({
      ingredientId,
      productIds: EMPTY_PRODUCT_IDS,
      loading: true
    })

    const ref = databaseRef(
      database,
      `${INGREDIENT_PRODUCTS_RDB}/${ingredientId}`
    )

    return onValue(
      ref,
      (snapshot) => {
        const memberships = snapshot.val()
        const productIds = memberships
          ? Object.keys(memberships).filter(
              (productId) => memberships[productId] === true
            )
          : EMPTY_PRODUCT_IDS

        setState({ ingredientId, productIds, loading: false })
      },
      (error) => {
        console.error('Error fetching ingredient product memberships:', error)
        setState({
          ingredientId,
          productIds: EMPTY_PRODUCT_IDS,
          loading: false
        })
      }
    )
  }, [ingredientId])

  if (state.ingredientId !== ingredientId) {
    return { productIds: EMPTY_PRODUCT_IDS, loading: Boolean(ingredientId) }
  }

  return { productIds: state.productIds, loading: state.loading }
}

export default useGetIngredientProductIds
